import store from '@/state/store'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['authfack/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/login/oauth2/code/azure',
        name: 'sso-callback',
        component: () => import('../views/pages/account/sso-callback'),
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('../views/pages/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['authfack/loggedIn']) {
                    next({ name: 'home' })
                } else {
                    next()
                }
            },
        },
    },
    // {
    //     path: '/confirm-password',
    //     name: 'confirm-password',
    //     component: () => import('../views/pages/account/confirm-password'),
    //     meta: {
    //         beforeResolve(routeTo, routeFrom, next) {
    //             if (store.getters['authfack/loggedIn']) {
    //                 next({ name: 'home' })
    //             } else {
    //                 next()
    //             }
    //         },
    //     },
    // },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                store.dispatch('authfack/logout')
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
            },
        },
    },
    {
        path: '/',
        name: 'home',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/account/home')
    },
    {
        path: '/users/admin',
        name: 'admin',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/users/admin')
    },
    {
        path: '/users/admin/create',
        name: 'create-admin',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/users/admin/form')
    },
    {
        path: '/users/admin/update',
        name: 'update-admin',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/users/admin/form')
    },
    {
        path: '/users/mobile',
        name: 'mobile',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/users/mobile')
    },
    {
        path: '/users/mobile/create',
        name: 'create-mobile',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/users/mobile/form')
    },
    {
        path: '/users/mobile/update',
        name: 'update-mobile',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/users/mobile/form')
    },
    {
        path: '/profile',
        name: 'profile',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/account/profile')
    },
    {
        path: '/report/searchlog',
        name: 'report-searchlog',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/reports/searchlog')
    },
    {
        path: '/report/lastlogin',
        name: 'report-lastlogin',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/reports/lastlogin')
    },
    {
        path: '*',
        name: 'error-404',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/error/404')
    },
    {
        path: '/error/500',
        name: 'error-500',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/error/500')
    },
]